import { type FC } from 'react'

import { Input, type InputProps } from 'base-ui'

type StoryblokBmiCalculatorNumberInputProps = Pick<
  InputProps,
  'name' | 'slotProps'
>

export const StoryblokBmiCalculatorNumberInput: FC<
  StoryblokBmiCalculatorNumberInputProps
> = ({ slotProps, ...rest }) => {
  return (
    <Input
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps?.input,
          inputMode: 'decimal',
        },
      }}
      type="number"
      {...rest}
    />
  )
}
